<template>
  <div id="app">
    <top :token="tokenVal" v-if="isLogin" v-show="flag"></top>
    <!-- <tab :tab="tabIndexVal" v-show="flag"></tab>  -->
    <router-view @loginStatus="loginStatus"></router-view>
    <foot v-show="flag"></foot>
    <div style="width:100px;height:185px;position: fixed;top:70%;right:20px;z-index:999;">
        <div class="phoneupload">
        <div style="padding-top:17px;text-align: center;width:100%">
          <img class="img1" src="./static/home/phoneactive.png" alt="">
          <img class="img2" src="./static/home/phone.png" alt="">
        </div>
        <div class="phonename">
          <p>手机APP下载</p>
        </div>
      </div>
      <div class="uploadImg">
        <div class="sanjiao">&#9660;</div>
        <div style="width:134px">
          <div class="imgwrap">
            <img src="./static/home/shixuncode.png" alt="">
          </div>
          <p class="imgp" style="text-align: center">实训APP</p>
        </div>
        <div style="width:134px">
          <div class="imgwrap">
            <img src="./static/home/wangchuangcode.png" alt="">
          </div>
          <p class="imgp" style="text-align: center">网创APP</p>
        </div>
        <div style="width:134px">
          <div class="imgwrap">
            <img src="./static/home/QRCode.png" alt="">
          </div>
          <p class="imgp" style="text-align: center">慕课APP</p>
        </div>
      </div>
      </div>
  </div>
</template>

<script>

import top from "./components/common/top.vue";
import tab from "./components/common/tab.vue";
import foot from "./components/common/footer.vue";

export default {
  name: "App",
  components: {
    top,
    tab,
    foot,
  },
  data() {
    return {
      isLogin: true,
      flag: true,
      tokenVal: "",
      tabIndexVal: 1,
      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 1,
      delay: 18,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      thedivShow: true,
    };
  },
  watch: {
    $route(e) {
      if (e.name == "login") {
        this.flag = true;
      } else if (e.name == "register") {
        this.flag = true;
      } else if (e.name == "forgetpwd") {
        this.flag = true;
      } else if (e.name == "completeinfor") {
        // this.flag = false;
        this.tokenVal = localStorage.token;
        this.flag = true;
      } else if (e.name == "home") {
        this.tokenVal = localStorage.token;
        this.flag = true;
      } else if (e.name == "me") {
        this.tabIndexVal = 0;
        this.flag = true;
      } else if (e.name == "policy") {
        //政策
        this.tabIndexVal = 2;
        this.flag = true;
      } else if (e.name == "policyDetail") {
        this.tabIndexVal = 2;
        this.flag = true;
      } else if (e.name == "feedback") {
        this.flag = false;
      } else if (e.name == "serve") {
        //服务
        this.tabIndexVal = 4;
        this.flag = true;
      } else {
        this.flag = true;
        this.tabIndexVal = undefined;
      }
    },
  },
  methods: {
    loginStatus(e) {
      this.isLogin = false
      this.$nextTick(() => {
        this.isLogin = true
      })
    }
  },
  created() {},
  mounted() {
    
  },
};
</script>

<style lang="less">
.phoneupload {
  position: absolute;
  width: 100px;
  height: 100px;
  background: #FFFFFF;
  border-radius: 10px;
  right: 0px;
  top: 43px;
  box-sizing: border-box;
  box-shadow: 0px 0px 13px 0px rgba(56, 56, 56, 0.13);
}
.phoneupload img {
  width: 23px;
  height: 41px;
  margin: 0 auto;
}

.phoneupload .img2 {
  display: none;
}
.phoneupload .phonename {
  padding-top: 11px;
  text-align: center;
  color: #3476C1;
  font-size: 14px;
  font-family: PingFang SC;
}
.phoneupload .img1 {
  display: block;
}
.phoneupload:hover {
  background: #3476C1;
}
.phoneupload:hover .img1 {
  display: none;
}
.phoneupload:hover .img2 {
  display: block;
}
.phoneupload:hover .phonename {
  color: #FFFFFF;
}
.phoneupload:hover ~ .uploadImg {
  display: flex;
}
.uploadImg {
  width: 458px;
  height: 187px;
  background: #FFFFFF;
  box-shadow: 0px 0px 38px 0px rgba(56, 56, 56, 0.2);
  border-radius: 6px;
  padding: 14px 14px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0px;
  right: 121px;
  z-index: 9999;
  display: none;
}
.sanjiao {
  position: absolute;
  right: -9px;
  top: 88px;
  transform: rotate(-90deg);
  color: #fff;
}
.imgp {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3476C1;
  line-height: 36px;
}
.imgwrap {
  width: 136px;
  height: 136px;
  border: 4px solid #CDE4FE;
  border-radius: 5px;
  box-sizing: border-box;
  
}
.imgwrap img {
  width: 120px;
  height: 120px;
  margin: 5px;
}
</style>
